import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Modal,
  ModalHeader
} from 'reactstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import cellEditFactory from 'react-bootstrap-table2-editor'
import withReactContent from 'sweetalert2-react-content'
import AsyncSelect from 'react-select/async'
import NumberFormat from 'react-number-format'
import Switch from 'react-switch'
import DateTime from 'react-datetime'
import Swal from 'sweetalert2'
import moment from 'moment';

import ReactSelect from 'components/Form/Select/Select'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import Loading from 'lib/loading'
import useForm from 'lib/useForm'
import useToggle from 'lib/useToggle'
import DuplicaCampanha from './DuplicaCampanha'
import EmMassaTab from './EmMassaTab'
import './style.css'

const formSwal = withReactContent(Swal)

const FormCampanha = ({ fechaModal, campanha_id, setCampanha_id }) => {

  const initialForm = {
    campanha_id: "",
    campanha: "",
    todosDias: "N",
    horario_inicio: "",
    horario_fim: "",
    data_encerramento: "",
    ativo: "S",
    segunda: "S",
    terca: "S",
    quarta: "S",
    quinta: "S",
    sexta: "S",
    sabado: "S",
    domingo: "S",
  }

  const initialFormProd = {
    campanha_itens_id: "",
    campanha_id: "",
    produto_id: "",
    filial_id: "",
    valor: "",
    total: "",
    prvenda:"",
    prpromocao:"",
    saldo: 0
  }

  const colunas = [
    {
      dataField: 'produto_id',
      text: 'Código',
      editable: false,
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'cod_barras',
      text: 'Cód. Barras',
      editable: false,
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'produto',
      text: 'Produto',
      editable: false,
      align: 'left',
      headerAlign: 'left',
      classes: 'col-produto',
      headerClasses: 'col-produto',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'lotes_campanha',
      text: 'Lotes',
      editable: false,
      headerStyle: { cursor: 'default' },
      formatter: (cellContent) => {
        if (!cellContent) return <span style={{ color: '#cbd5e1', fontSize: 11 }}>—</span>;
        try {
          const lotes = JSON.parse(cellContent);
          const texto = lotes.map(l => l.num_lote).join(', ');
          return (
            <span style={{ fontSize: 11, color: '#0369a1', fontWeight: 600 }}>
              <i className="fa fa-tag" style={{ marginRight: 4 }} />
              {texto}
            </span>
          );
        } catch (e) {
          return <span style={{ fontSize: 11, color: '#0369a1' }}>{cellContent}</span>;
        }
      }
    },
    {
      dataField: 'prod_saldo',
      text: 'Saldo',
      editable: false,
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'valor',
      text: 'Valor na campanha',
      // type: "number",
      headerStyle: { cursor: 'pointer' },
      // formatter: (cellContent, row) => {console.log(cellContent); console.log(row);  return (cellContent)}
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))}
    },
    {
      dataField: 'ativo',
      text: 'Ativo',
      align: 'center',
      editable: false,
      headerStyle: { cursor: 'pointer' },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => { desativarProduto(row) },
      },
      formatter: (cellContent, row) => {
        return (
          <>
            <Switch
              id        = {row.produto_id}
              className = "react-switch"  
              height    = {15}
              width     = {35}
              onColor   = '#6bd098'
              checked   = {row.ativo === 'S' ? true : false}
              onChange  = {(e)=>{}}
            />
          </>
        );
      },
    }
  ]

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(initialForm)
  const [formProd, onChangeProd, setFormProd]                   = useForm(initialFormProd)
  const [loading, setLoading]                                   = useState(true)
  const [loadingListProd, setLoadingListProd]                   = useState(false)
  const [activeTab, setActiveTab]                               = useState('1')
  const [listaLoja, setListaLoja]                               = useState([])
  const [listaProdCampanha, setListaProdCampanha]               = useState([])
  const [filial, setFilial]                                     = useState(null)
  const [duplicarBtn, setDuplicarBtn]                           = useState(true)
  const [camposProduto, setCamposProduto]                       = useState(true)
  const [produtoSaldo, setProdutoSaldo]                         = useState(true)
  const [modalDuplica, setModalDuplica]                         = useToggle(false);

  const clickProdutoSaldo = () => setProdutoSaldo(!produtoSaldo)

  /* Retorna quantos dias faltam para encerrar (negativo = já passou) */
  const diasEncerramento = () => {
    const dateStr = form.data_encerramento;
    if (!dateStr || dateStr === '00/00/0000') return null;
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;
    const [d, m, y] = parts;
    const date = new Date(y, m - 1, d);
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return Math.floor((date - hoje) / (1000 * 60 * 60 * 24));
  };

  const bannerEncerramento = () => {
    const dias = diasEncerramento();
    if (dias === null) return null;

    let bg, border, iconColor, iconClass, texto;

    if (dias < 0) {
      bg        = '#fef2f2';
      border    = '4px solid #ef4444';
      iconColor = '#dc2626';
      iconClass = 'fa fa-ban';
      texto     = `Campanha encerrada — data de encerramento: ${form.data_encerramento}`;
    } else if (dias === 0) {
      bg        = '#fff7ed';
      border    = '4px solid #f97316';
      iconColor = '#ea580c';
      iconClass = 'fa fa-exclamation-triangle';
      texto     = 'Atenção: esta campanha encerra hoje!';
    } else if (dias <= 7) {
      bg        = '#fefce8';
      border    = '4px solid #eab308';
      iconColor = '#ca8a04';
      iconClass = 'fa fa-clock';
      texto     = `Atenção: esta campanha encerra em ${dias} dia${dias > 1 ? 's' : ''}`;
    } else {
      return null;
    }

    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        background: bg, borderLeft: border,
        borderRadius: '4px', padding: '10px 16px', margin: '8px 0 16px',
        width: '100%'
      }}>
        <i className={iconClass} style={{ color: iconColor, fontSize: '18px', flexShrink: 0 }} />
        <span style={{ color: '#1e293b', fontWeight: 700, fontSize: '13px' }}>
          {texto}
        </span>
      </div>
    );
  };

  const asyncSelectRef = useRef(null)

  const limparSelect = () => {
    console.log(asyncSelectRef.current);
    if (asyncSelectRef.current) {
      asyncSelectRef.current.select.select.clearValue();
    }
  };
  
  const listarCampanha = (id = campanha_id) => {
    if (id !== '') {
      const url = rotas.campanha,
            retorno = rest.get(url + 'editar.php?campanha_id=' + id);

      retorno.then(ret => {
        if (ret.success && ret.success == 'S') {
          let lista = ret.lista[0]
          setForm(lista)
        }
        setLoading(false)
      })
    } else {
      setLoading(false)
    }
  }

  const listaLojas = () => {
    let lista = []
    try {
      const retorno = rest.get(rotas.lojas)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = { "id": ret.lista[i].filial_id, "title": ret.lista[i].cnpj + " - " + ret.lista[i].fantasia }
          }
          setListaLoja(lista)
        } else {
          setListaLoja([])
        }
        setLoading(false)
      })
      return (lista)
    } catch (err) {
      setLoading(false)
    }
  }

  const pesquisaProdutos = (value) => {
    if (value.length > 2) {
      const parametros  = {
              filial_id: filial.id,
              produto: value,
              saldo: produtoSaldo ? 'S' : 'N'
            },
            url         = rotas.campanha+"pesquisaProduto.php",
            retorno     = rest.post(url, parametros)

      return retorno.then(ret => {
        let lista = [];
        if (ret.lista) {
          ret.lista.map(prod => {
            lista.push({
              label: prod.produto+" ("+prod.fornecedor+")",
              value: prod.produto_id,
              prvenda: prod.prod_prvenda,
              prpromocao: prod.prod_prpromocao,
              saldo: prod.prod_saldo
            })
          })
        }
        return lista;
      }).catch(() => []);
    }
    return Promise.resolve([]);
  }

  const produtoSelecionado = (selecProduto) => {
    if (selecProduto) {
      let produto = {
        campanha_id : form.campanha_id,
        filial_id : filial.id,
        produto_id: selecProduto.value,
        valor: selecProduto.prpromocao !== '0.00' ? parseFloat(selecProduto.prpromocao) : parseFloat(selecProduto.prvenda),
        prvenda: parseFloat(selecProduto.prvenda),
        prpromocao: parseFloat(selecProduto.prpromocao),
        saldo: parseInt(selecProduto.saldo)
      }
      setFormProd(produto)
    }
  }

  const listaProdutos = () => {
    setLoadingListProd(true)
    setListaProdCampanha([])
    try{
      const retorno = rest.get(rotas.campanha + 'listaProdutos.php?campanha_id='+ campanha_id +'&filial_id=' + filial.id)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          setListaProdCampanha(ret.lista)
        }else{
          setListaProdCampanha([])
        }
        setLoadingListProd(false)
      }).catch(() => {
        setListaProdCampanha([])
        setLoadingListProd(false)
      })
    }catch(err){
      console.log(err);
      setLoadingListProd(false)
      setListaProdCampanha([])
    }
  }

  const inserirProduto = () => {
    if(parseFloat(formProd.valor) <= 0){
      formSwal.fire('Produto com valor zerado!', 'Por favor, informe um valor maior que zero', 'warning')

    }else if (formProd.produto_id != '' && parseFloat(formProd.valor) > 0) {
      formSwal.queue([{
        title: 'Deseja inserir o produto na lista da campanha ?',
        confirmButtonText: 'Inserir',
        showCancelButton: true,
        text:'Essas informações serão salvas no banco',
        showLoaderOnConfirm: true,
        cancelButtonColor: '#d33',
        preConfirm: () => {
          const url = rotas.campanha+'inserirProduto.php'
  
          return rest.put(url, formProd)
          .then(ret => {
            if (ret.success && ret.success == 'S') {
              limparSelect()
              setFormProd(initialFormProd)
              listaProdutos()
              formSwal.fire('Salvo!', ret.msg, 'success')
            }else{
              formSwal.fire('Erro!', ret.msg, 'error')
            }
          })
        }
      }])
    }else{
      formSwal.fire('Produto não selecionado!', 'Por favor, selecione um produto', 'warning')
    }
  }

  const desativarProduto = (row) => {

    let msg = row.ativo == 'S' ? 'desativar' : 'ativar'
    
    formSwal.queue([{
      title: 'Deseja '+msg+' o produto da lista do Kit ?',
      confirmButtonText: msg[0].toUpperCase() + msg.substring(1),
      showCancelButton: true,
      // text:'Essas informações serão salvas no banco',
      input: 'checkbox',
      inputPlaceholder: 'Marque para replicar nas lojas',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: (result) => {

        let replicar  = result == 1 ? 'S' : 'N'
        const url     = rotas.campanha+'desatisarProduto.php?replicar='+replicar

        return rest.post(url, row)
        .then(ret => {
          if (ret.success && ret.success == 'S') {
            listaProdutos()
            formSwal.fire('Salvo!', ret.msg, 'success')
          }else{
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        })
      }
    }])
  }

  //componente datatime, campo vazio
  const focousOut = (value) => {
    if(!moment(value).isValid()) {
      setForm({ ...form, data_encerramento: '' });
    }
  }

  const handleSubmit = (evt) => {
    evt.preventDefault()

    const hInicio = moment(form.horario_inicio,'HH:mm').hours(),
          hFim = moment(form.horario_fim,'HH:mm').hours();

    if(hInicio >= hFim){
      Swal.fire('Atenção','O horário inicial deve ser menor que o horário final','warning');
      return;
    }

    if (form.data_encerramento == '00/00/0000' || form.data_encerramento == '') {
      Swal.fire('Atenção','O campo da data de encerramento é obrigatório','warning');
      return
    }

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text: 'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.campanha + 'gravar.php'

        if (campanha_id !== '') {
          return rest.post(url, form)
            .then(ret => {

              if (ret.success && ret.success == 'S') {
                listarCampanha(campanha_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })

        } else {
          return rest.put(url, form)
            .then(ret => {
              if (ret.success && ret.success == 'S') {
                setCampanha_id(ret.campanha_id)
                setForm({ ...form, ['campanha_id']: ret.campanha_id });
                listarCampanha(ret.campanha_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
        }
      }
    }])
  }

  function  beforeSaveCell ( oldValue, newValue, row, column, done ) {

    const formattedValue = newValue.replace(/\s/g, '').replace(',', '.');

    if (oldValue != formattedValue) {

      if (!isNaN(formattedValue) && formattedValue > 0) {
        row[column.dataField] = formattedValue;

        const url = rotas.campanha+'gravarProduto.php'
    
        return rest.post(url, row)
        .then(ret => {
          if (ret.success && ret.success == 'S') {
            listaProdutos()
            formSwal.fire('Salvo!', column.text+' do produto alterado.', 'success')
          }else{
            listaProdutos()
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        })
        .catch(error => {
          console.error('Erro ao salvar o valor:', error);
          listaProdutos();
        });

      }else{
        console.log(formattedValue);
        listaProdutos()
      }
    }
  }

  const abreModalDuplica = () => {
    if (listaProdCampanha.length > 0) {
      setModalDuplica()
    }else{
      formSwal.fire('Lista de produtos vazia!', 'Favor, inserir produtos na lista antes de replicar.', 'warning')
    }
  }

  const fechaModalDuplica = () => {
    setModalDuplica()
  }

  const activeTabProdutos = () => {
    if (campanha_id !== '') {
      setActiveTab('2')
    }
  }

  const selectFilial = (e) => {
    setFormProd(initialFormProd)
    setFilial(e)
    setDuplicarBtn(false)
    limparSelect()
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listarCampanha();
    }
  }, [])

  useEffect(() => {
    if (activeTab == '2') {
      listaLojas();
      if (filial) {
        listaProdutos();
      }
    }
  }, [activeTab])

  useEffect(() => {
    if (activeTab == '2') {
      // listaProdtudos();
      if (filial) {
        setCamposProduto(false)
        listaProdutos()
      }
    }
  }, [filial])

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading tipo='componente' />
      </ModalBody>
    )
  }

  return (
    <>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">

          <Nav pills className="nav-pills-default justify-content-center mb-3">
            <NavItem>
              <NavLink
                className = {activeTab == '1' ? 'active' : ''}
                onClick   = {() => setActiveTab('1')}
              >
                Dados da campanha
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab == '2' ? 'active' : ''}
                onClick = {() => activeTabProdutos()}
              >
                Lista de Produtos
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab == '3' ? 'active' : ''}
                onClick   = {() => {
                  if (!campanha_id) {
                    formSwal.fire('Atenção', 'Salve a campanha antes de adicionar produtos em massa.', 'warning');
                    return;
                  }
                  if (activeTab !== '3') listaLojas();
                  setActiveTab('3');
                }}
              >
                <i className="fa fa-th-list mr-1" />Adicionar em Massa
              </NavLink>
            </NavItem>
          </Nav>

          <hr />

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Form onSubmit={handleSubmit}>

                {bannerEncerramento()}

                <Row>
                  <Col md='3'>
                    <FormGroup>
                      <Label for="campanha_id">Código da campanha</Label>
                      <Input
                        disabled
                        id    = "campanha_id"
                        name  = "campanha_id"
                        style = {{ background: '#F9F9F9', cursor: 'default' }}
                        type  = "number"
                        value = {campanha_id}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup check inline className="mb-0 mt-4">
                      <Label check for="ativo">
                        <Input
                          id              = "ativo"
                          name            = "ativo"
                          type            = "checkbox"
                          defaultChecked  = {form.ativo == 'S' ? true : false}
                          onChange        = {onChange('ativo')}
                        />
                        <span className="form-check-sign" />Campanha Ativo
                      </Label>
                    </FormGroup>
                  </Col>

                </Row>

                <Row>
                  <Col md='6'>
                    <FormGroup>
                      <Label for="campanha">Nome</Label>
                      <Input
                        required
                        id            = "campanha"
                        name          = "campanha"
                        defaultValue  = {form.campanha}
                        onChange      = {onChange('campanha')}
                        maxLength     = {50}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="2">
                    <FormGroup>
                      <Label for="horario_inicio">Horário inicial</Label>
                      <Input
                        required
                        id            = "horario_inicio"
                        name          = "horario_inicio"
                        type          = "time"
                        defaultValue  = {form.horario_inicio}
                        onChange      = {onChange('horario_inicio')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="2">
                    <FormGroup>
                      <Label for="horario_fim">Horário final</Label>
                      <Input
                        required
                        id            = "horario_fim"
                        name          = "horario_fim"
                        type          = "time"
                        defaultValue  = {form.horario_fim}
                        onChange      = {onChange('horario_fim')}
                      />
                    </FormGroup>

                  </Col>

                  <Col md="2">
                  <FormGroup>
                      <Label for="data_encerramento">Data encerramento</Label>
                      <DateTime
                        required
                        name          = "data_encerramento"
                        timeFormat    = {false}
                        closeOnSelect = {true}
                        dateFormat    = "DD/MM/YYYY"
                        value         = {form.data_encerramento}
                        onChange      = {onChangeDate('data_encerramento')}
                        onBlur        = {focousOut}
                        // renderInput={(props) => {
                        //   return <input {...props} value={(form.data_encerramento) ? props.value : ''} />
                        // }}
                      >
                      </DateTime>
                    </FormGroup>
                  </Col>
                  
                </Row>

                <Row className="card-2">
                  <Col md="12">
                    <span className="tag-card">
                      Selecione os dias desejados
                    </span>
                  </Col>

                  <Col md='12' className="text-center">
                    <FormGroup check inline className="mb-0 mt-4 mr-4">
                      <Label check for="segunda">
                        <Input
                          id="segunda"
                          name="segunda"
                          type="checkbox"
                          defaultChecked={form.segunda == 'S' ? true : false}
                          onChange={onChange('segunda')}
                        />
                        <span className="form-check-sign" />Segunda-feira
                      </Label>
                    </FormGroup>
                    <FormGroup check inline className="mb-0 mt-4 mr-4">
                      <Label check for="terca">
                        <Input
                          id              = "terca"
                          name            = "terca"
                          type            = "checkbox"
                          defaultChecked  = {form.terca == 'S' ? true : false}
                          onChange        = {onChange('terca')}
                        />
                        <span className="form-check-sign" />Terça-feira
                      </Label>
                    </FormGroup>
                    <FormGroup check inline className="mb-0 mt-4 mr-4">
                      <Label check for="quarta">
                        <Input
                          id              = "quarta"
                          name            = "quarta"
                          type            = "checkbox"
                          defaultChecked  = {form.quarta == 'S' ? true : false}
                          onChange        = {onChange('quarta')}
                        />
                        <span className="form-check-sign" />Quarta-feira
                      </Label>
                    </FormGroup>
                    <FormGroup check inline className="mb-0 mt-4 mr-4">
                      <Label check for="quinta">
                        <Input
                          id              = "quinta"
                          name            = "quinta"
                          type            = "checkbox"
                          defaultChecked  = {form.quinta == 'S' ? true : false}
                          onChange        = {onChange('quinta')}
                        />
                        <span className="form-check-sign" />Quinta-feira
                      </Label>
                    </FormGroup>
                    <FormGroup check inline className="mb-0 mt-4 mr-4">
                      <Label check for="sexta">
                        <Input
                          id              = "sexta"
                          name            = "sexta"
                          type            = "checkbox"
                          defaultChecked  = {form.sexta == 'S' ? true : false}
                          onChange        = {onChange('sexta')}
                        />
                        <span className="form-check-sign" />Sexta-feira
                      </Label>
                    </FormGroup>
                    <FormGroup check inline className="mb-0 mt-4 mr-4">
                      <Label check for="sabado">
                        <Input
                          id              = "sabado"
                          name            = "sabado"
                          type            = "checkbox"
                          defaultChecked  = {form.sabado == 'S' ? true : false}
                          onChange        = {onChange('sabado')}
                        />
                        <span className="form-check-sign" />Sábado
                      </Label>
                    </FormGroup>
                    <FormGroup check inline className="mb-0 mt-4 mr-4">
                      <Label check for="domingo">
                        <Input
                          id              = "domingo"
                          name            = "domingo"
                          type            = "checkbox"
                          defaultChecked  = {form.domingo == 'S' ? true : false}
                          onChange        = {onChange('domingo')}
                        />
                        <span className="form-check-sign" />Domingo
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Col className="text-center p-3">
                  <Button type="submit" className="mb-0 mt-0" color="success" size="md" >
                    Salvar
                  </Button>
                  <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
                    Fechar
                  </Button>
                </Col>
              </Form>
            </TabPane>

            <TabPane tabId="2">

              <Row>
                <Col md="8">
                  <Label for="lojas">Selecione a loja para a visialização dos produtos</Label>
                  <ReactSelect
                    required
                    id          = "lojas"
                    key         = "lojas"
                    name        = "lojas"
                    placeholder = "Selecione a loja"
                    className   = "m-0 w-100"
                    options     = {listaLoja}
                    value       = {filial}
                    onChange    = {selectFilial}
                  >
                  </ReactSelect>
                </Col>

                <Col md="4" className="d-flex pt-2">
                  <Button
                    block
                    color     = "info"
                    disabled  = {duplicarBtn}
                    onClick   = {abreModalDuplica}
                    style={{height: '43px'}}
                  >Replicar lista entre lojas
                  </Button>
                </Col>

              </Row>
              <hr />

              <Row>
                <Col md="8">
                  <FormGroup>
                    <Label for="produtos">Selecione o produto para inserir na campanha</Label>
                    <AsyncSelect
                      cacheOptions
                      id          = "produtos"
                      key         = "produtos"
                      name        = "produtos"
                      placeholder = "Código de barras ou descrição ..."
                      onChange    = {produtoSelecionado}
                      loadOptions = {pesquisaProdutos}
                      isDisabled  = {camposProduto}
                      ref         = {asyncSelectRef}
                      // value={null} //ezavia valor quando selecionado
                    />
                  </FormGroup>
                </Col>

                <Col md="4">
                  <FormGroup check inline className="mb-0 mt-4">
                    <Label check for="produtoSaldo">
                      <Input
                        id              = "produtoSaldo"
                        name            = "produtoSaldo"
                        type            = "checkbox"
                        defaultChecked  = {produtoSaldo}
                        onClick         = {clickProdutoSaldo}
                        disabled        = {camposProduto}
                      />
                      <span className="form-check-sign" />Apenas produtos com saldo
                    </Label>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md='2'>
                  <FormGroup>
                    <Label for="quantidade">saldo atual</Label>
                    <Input
                      id          = "quantidade"
                      name        = "quantidade"
                      type        = "text"
                      placeholder = "0"
                      min         = "0"
                      style       = {{background: '#F9F9F9'}}
                      disabled    = {true}
                      value       = {formProd.saldo}
                    />
                  </FormGroup>
                </Col>

                <Col md='2'>
                  <FormGroup>
                    <Label for="prvenda">preço venda</Label>
                    <NumberFormat
                      required
                      fixedDecimalScale
                      id                = "prvenda"
                      name              = "prvenda"
                      placeholder       = "0,00"
                      maxLength         = {20}
                      decimalScale      = {2}
                      allowNegative     = {false}
                      className         = {"form-control"}
                      prefix            = {"R$ "}
                      decimalSeparator  = {','}
                      style             = {{background: '#F9F9F9'}}
                      disabled          = {true}
                      value             = {formProd.prvenda}
                    />
                  </FormGroup>
                </Col>

                <Col md='2'>
                  <FormGroup>
                    <Label for="prpromocao">preço promoção</Label>
                    <NumberFormat
                      required
                      fixedDecimalScale
                      id                = "prpromocao"
                      name              = "prpromocao"
                      placeholder       = "0,00"
                      maxLength         = {20}
                      decimalScale      = {2}
                      allowNegative     = {false}
                      className         = {"form-control"}
                      prefix            = {"R$ "}
                      decimalSeparator  = {','}
                      style             = {{background: '#F9F9F9'}}
                      disabled          = {true}
                      value             = {formProd.prpromocao}
                    />
                  </FormGroup>
                </Col>

                <Col md='2'>
                  <FormGroup>
                    <Label for="valor">Valor</Label>
                    <NumberFormat
                      required
                      fixedDecimalScale
                      id                = "valor"
                      name              = "valor"
                      placeholder       = "0,00"
                      maxLength         = {20}
                      decimalScale      = {2}
                      allowNegative     = {false}
                      className         = {"form-control"}
                      prefix            = {"R$ "}
                      decimalSeparator  = {','}
                      value             = {formProd.valor}
                      onChange          = {onChangeProd('valor')}
                      disabled          = {camposProduto}
                    />
                  </FormGroup>
                </Col>

                <Col md="4" className="d-flex pt-2">
                  <Button
                    block
                    color     = "warning"
                    disabled  = {camposProduto}
                    onClick   = {inserirProduto}
                  >INSERIR PRODUTO
                  </Button>
                </Col>
              </Row>

              <Row>
              {
                  loadingListProd ?
                    <Col md="12">
                      <Loading tipo='componente'/>
                    </Col>
                  :
                    <Col md="12">
                    <BootstrapTable
                      striped
                      keyField          = 'produto_id'
                      data              = {listaProdCampanha}
                      columns           = {colunas}
                      noDataIndication  = "Nenhum registro encontrado"
                      cellEdit          = {
                                            cellEditFactory({
                                              blurToSave: true,
                                              mode: 'dbclick',
                                              autoSelectText: true,
                                              beforeSaveCell
                                            })
                                          }
                    />
                    {/* <Col>
                      <footer className="blockquote-footer text-right text-danger">Total do Kit <cite title="Source Title">{valorProdutosKit}</cite></footer>
                    </Col> */}
                    </Col>
                }
              </Row>

              <Col className="text-center p-3">
                <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
                  Fechar
                </Button>
              </Col>
            </TabPane>

            {/* ── TAB 3: Adicionar em Massa ── */}
            <TabPane tabId="3">
              <EmMassaTab
                campanha_id    = {campanha_id}
                filial         = {filial}
                listaLoja      = {listaLoja}
                onFilialChange = {selectFilial}
              />
              <Col className="text-center p-3">
                <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
                  Fechar
                </Button>
              </Col>
            </TabPane>

          </TabContent>

        </ModalBody>
      </FormGroup>

      <Modal
        key     = 'modaDuplica'
        size    = 'md'
        isOpen  = {modalDuplica}
      >
        <ModalHeader>Replicar lista de produtos entre as lojas</ModalHeader>
        <DuplicaCampanha
          listaProdutos = {listaProdCampanha}
          fechaModal    = {fechaModalDuplica}
        >
        </DuplicaCampanha>
      </Modal>

    </>
  )
}

export default FormCampanha
